(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('whoswho-map', {
            parent: 'whoswho',
            url: '/whoswho-map?page&sort',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL'],
                pageTitle: 'Axenteev | Who\s Who'
            },
            views: {
                'content@whoswho': {
                    templateUrl: 'app/whoswho/map/whoswho-map.html',
                    controller: 'WhoswhoMapController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }
        })

        .state('whoswho-map.message-libre', {
            parent: 'whoswho-map',
            url: '/message-libre/{userId}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message-libre/message-libre-dialog.html',
                    controller: 'MessageLibreDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Whoswho', function(Whoswho) {
                            return Whoswho.getUser({userId : $stateParams.userId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('whoswho-map', null, { reload: false });
                }, function() {
                    $state.go('whoswho-map');
                });

            }]
        })
       ;
    }
})();
